import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFeedbackForm from './Forms/Feedback/ErrorFeedback';

const fallbackRender = ({ error, resetErrorBoundary }) => {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <div className="container">
      <div className="col-8 offset-2 bg-fff-50 my-5" role="alert">
        <div className="p-20 pb-0">
          <h3 className="text-center">Something went wrong</h3>
          <p>There was an error when trying to access the page:</p>
          <pre className="mb-0" style={{ color: 'red' }}>{error.message}</pre>
        </div>
        <ErrorFeedbackForm triggeringError={error} subject="Error Report: Snapshot Gallery" />
      </div>
    </div>
  );
};
const BoundaryWrapper = Component => (props) => {
  return (
    <ErrorBoundary
      fallbackRender={fallbackRender}
    >
      <Component {...props} />
    </ErrorBoundary>
  );
};

export default BoundaryWrapper;
